import { FREQ_W, DUR_W, FRIC_W, PRED_W } from '../types';
import type { Segment } from '../migrations/legacyEdge';

export function impactScore(seg: Segment): number {
  return (
    FRIC_W[seg.friction ?? 'none'] *
    FREQ_W[seg.freq ?? 'adhoc'] *
    DUR_W[seg.dur ?? 'mins'] *
    PRED_W[seg.pred ?? 'yes']
  );
}

export function impactColor(score: number): string | null {
  if (score <= 4)  return null;
  if (score <= 10) return '#e0a800';
  if (score <= 24) return '#e07b3a';
  return '#c0392b';
}

export function impactLabel(score: number): string | null {
  if (score <= 4)  return null;
  if (score <= 10) return '⚡';
  if (score <= 24) return '⚡⚡';
  return '⚡⚡⚡';
}
